<template>
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.333 8.93332V10.9333C11.333 13.6 10.2663 14.6667 7.59967 14.6667H5.06634C2.39967 14.6667 1.33301 13.6 1.33301 10.9333V8.39999C1.33301 5.73332 2.39967 4.66666 5.06634 4.66666H7.06634"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.3331 8.93332H9.19974C7.59974 8.93332 7.06641 8.39999 7.06641 6.79999V4.66666L11.3331 8.93332Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.7334 1.33334H10.4001"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66699 3.33334C4.66699 2.22668 5.56033 1.33334 6.66699 1.33334H8.41366"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6663 5.33334V9.46001C14.6663 10.4933 13.8263 11.3333 12.793 11.3333"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.667 5.33334H12.667C11.167 5.33334 10.667 4.83334 10.667 3.33334V1.33334L14.667 5.33334Z"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
